import { styled } from "@mui/material";

import makeStyles from '@mui/styles/makeStyles';

export const ButtonText = styled("span")(() => ({
  whiteSpace: "nowrap",
  fontFamily: "Manrope",
  fontWeight: 600,
  fontSize: "14px",
  lineHeight: "20px",
  letterSpacing: "0.1px",
  textAlign: "center",
  color: "#FFFFFF"
}));

const styles = makeStyles(() => ({
  rolesComponentWrapper: {},
  gridWrapper: {
    // "& .MuiTableCell-head": {
    //   "& *": {
    //     padding: "0px !important",
    //     color: "#1D2939 !important",
    //   },
    //   padding: "8px 16px !important",
    //   gap: "12px",
    //   fontFamily: "Manrope",
    //   fontSize: "12px",
    //   fontStyle: "normal",
    //   fontWeight: 700,
    //   lineHeight: "16px",
    //   letterSpacing:" 0.5px",
    //   alignSelf: "stretch",
    // },
    // "& .MuiTableCell-body": {
    //   height: "64px",
    //   minHeight: "40px",
    //   maxHeight: "64px",
    //   padding: "0px 16px !important",
    // },
  },
  rowStyle: {
    // color: "#475467",
    // fontFamily: "Manrope",
    // fontSize: "12px",
    // fontStyle: "normal",
    // fontWeight: 400,
    // lineHeight: "16px",
    // letterSpacing: "0.4px",
  },
  statusBadge: {
    borderRadius: 100,
    borderWidth: 1,
    gap: 8,
    background: "#FEE4E2 !important",
    border: "1px solid #E0E2E7",
    padding: "2px 8px",
    fontWeight: 700,
    fontSize: 11,
    lineHeight: "16px",
    color: "#F97066 !important",
    fontFamily: "Manrope",
  },
  statusBadgeActive: {
    background: "#ECFDF3 !important",
    border: "1px solid #ECFDF3",
    color: "#027A48 !important",
  },
  statusBadgeInactive: {
    background: "#FEF3F2 !important",
    border: "1px solid #FEF3F2",
    color: "#B42318 !important",
  },
  button: {
    cursor: "pointer",
  },
  changeStatusButton: {
    whiteSpace: "nowrap",
    "& span > div": {
      display: "flex",
      alignItems: "center",
    },
  },
  createRoleButton: {
    whiteSpace: "nowrap",
    color: "#FFFFFF !important",
  },
  infoIcon: {
    fontSize: "10px",
    marginRight: "8px",
  },
  upgradeVersionTooltip: {
    display: "flex",
    alignItems: "center",
  },
  selectStatus: {
    minWidth: "124px",
    maxWidth: "fit-content",
    height: "40px",
    padding: "10px 12px",
    gap: "12px",
  },
  selectStatusItem: {
    color: "#475467",
    fontFamily: "Manrope",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "0.25px",
    padding: "8px 12px", 
    gap: "12px",
  },
  rowActionExtra: {
    padding: "4.8px",
    gap: "4.8px"
  },
  newRecord: {
    minWidth: "122px",
    height: "40px",
    gap: "8px",
    padding: "10px 20px 10px 16px",
  }
}));

export default styles;
